import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as global_var from '../global.variable';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ForgetPasswordService {
  constructor(private http: HttpClient, private router: Router) {}

  // function for forget password
  forgetPassword(email: any) {
    return this.http
      .post(global_var.apiUrl + 'forgetPass', { email: email })
      .pipe()
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
